import { configureStore } from "@reduxjs/toolkit";
import sidebar from "./sidebar";
import AdminSlice from "./AdminUserReducer";
import LoadingSlice from "./LoadingReducer";
import popUpSlice from "./PopUpReducer";
import categorySlice from "./categoryReducer";
import Mfslice from "./MutualFundAddReducer";
const store = configureStore({
  reducer: {
    MutualFund: Mfslice.reducer,
    popUpState: popUpSlice.reducer,
    LoadingState: LoadingSlice.reducer,
    sidebarShow: sidebar.showAndHide,
    AdminUser: AdminSlice.reducer,
    categroyState: categorySlice.reducer,
  },
});
export default store;
